import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=87b2b15a&scoped=true"
import script from "./ProjectIndex.vue?vue&type=script&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&lang=js"
import style0 from "./ProjectIndex.vue?vue&type=style&index=0&id=87b2b15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b2b15a",
  null
  
)

export default component.exports